import { FC } from 'react';
import { FCProps } from '../../types/props.types';

const FluidContainer: FC<FCProps> = ({ children, ...props }) => {
  const { className } = props;
  return <div className={`container-fluid ${className}`}>{children}</div>;
};

export default FluidContainer;
